export default [
    // monthly installment table data
    {
        im2u_liabilities:[
            {
                im2u_liability_id: 45,
                im2u_data_id: 118485,
                customer_id: 3075,
                loan_statue: 'HSLNFNCE',
                loan_statue_name: 'Housing Loan',
                lender_type: 'CB',
                credit_limit: 338244.00,
                customer_curr_outstanding: 314037.00,
                customer_curr_installment: 694.00,
                customer_annual_curr_installment: 694.00 * 12,
                admin_month_curr_installment: 0,
                admin_annual_curr_installment: null,
                admin_curr_outstanding: 0,
                remark: '',
            },
            {
                im2u_liability_id: 54,
                im2u_data_id: 118493,
                customer_id: 3075,
                loan_statue: 'HSLNFNCE',
                loan_statue_name: 'Housing Loan',
                lender_type: 'CB',
                credit_limit: 4435.00,
                customer_curr_outstanding: 5346.00,
                customer_curr_installment: 543.00,
                customer_annual_curr_installment: 543.00 * 12,
                admin_month_curr_installment: 0,
                admin_annual_curr_installment: null,
                admin_curr_outstanding: 0,
                remark: '',
            },
            {
                im2u_liability_id: 46,
                im2u_data_id: 118487,
                customer_id: 3075,
                loan_statue: 'CRDTCARD',
                loan_statue_name: 'Credit Card',
                lender_type: 'OTH',
                credit_limit: 338244.00,
                customer_curr_outstanding: 314037.00,
                customer_curr_installment: 694.00,
                customer_annual_curr_installment: 694.00 * 12,
                admin_month_curr_installment: 0,
                admin_annual_curr_installment: null,
                admin_curr_outstanding: 0,                
                remark: '',
            },
            {
                im2u_liability_id: 53,
                im2u_data_id: 118492,
                customer_id: 3075,
                loan_statue: 'CRDTCARD',
                loan_statue_name: 'Credit Card',
                lender_type: 'OTH',
                credit_limit: 4325.00,
                customer_curr_outstanding: 32144.00,
                customer_curr_installment: 454.00,
                customer_annual_curr_installment: 454.00 * 12,
                admin_month_curr_installment: 0,
                admin_annual_curr_installment: null,
                admin_curr_outstanding: 0,                
                remark: '',
            },
            {
                im2u_liability_id: 48,
                im2u_data_id: 118488,
                customer_id: 3075,
                loan_statue: 'PCPASCAR',
                loan_statue_name: 'Car Loan',
                lender_type: 'CB',
                credit_limit: 118000.00,
                customer_curr_outstanding: 47827.00,
                customer_curr_installment: 1350.00,
                customer_annual_curr_installment: 1350.00 * 12,
                admin_month_curr_installment: 1000,
                admin_annual_curr_installment: null,
                admin_curr_outstanding: 0,                
                remark: '',
            },
            {
                im2u_liability_id: 50,
                im2u_data_id: 118489,
                customer_id: 3075,
                loan_statue: 'ISPWNBKG',
                loan_statue_name: 'Pawnbroking',
                lender_type: 'CB',
                credit_limit: 60857.00,
                customer_curr_outstanding: 57370.00,
                customer_curr_installment: 284.00,
                customer_annual_curr_installment: 284.00 * 12,
                admin_month_curr_installment: 0,
                admin_annual_curr_installment: null,
                admin_curr_outstanding: 0,                
                remark: '',
            },
            {
                im2u_liability_id: 51,
                im2u_data_id: 118490,
                customer_id: 3075,
                loan_statue: 'PELNFNCE',
                loan_statue_name: 'Personal Loans',
                lender_type: 'CB',
                credit_limit: 148932.00,
                customer_curr_outstanding: 42179.00,
                customer_curr_installment: 457.00,
                customer_annual_curr_installment: 457.00 * 12,
                admin_month_curr_installment: 0,
                admin_annual_curr_installment: null,
                admin_curr_outstanding: 0,                
                remark: '',
            },
            {
                im2u_liability_id: 52,
                im2u_data_id: 118491,
                customer_id: 3075,
                loan_statue: 'OTLNFNCE',
                loan_statue_name: 'Other Loan',
                lender_type: 'CB',
                credit_limit: 338245.00,
                customer_curr_outstanding: 324127.00,
                customer_curr_installment: 700.00,
                customer_annual_curr_installment: 700.00 * 12,
                admin_month_curr_installment: 500.00,
                admin_annual_curr_installment: null,
                admin_curr_outstanding: 500.00,                
                remark: '',
            },
        ],
        total_month_curr_installment: 4179.00,
        total_annual_curr_installment: 50148.00,
        total_current_liability: 737713,
        total_long_term_liability: 361864,
    }
]